var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider__container"},[_c('div',{staticClass:"visual"},[_c('img',{attrs:{"src":_vm.visual}})]),_vm._v(" "),_c('div',{staticClass:"slider",attrs:{"id":_vm.addIdentifier}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b746e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/minigames/impactcalculator/RoundSlider.vue
// module id = Le6Q
// module chunks = 0